import type { HttpAdapter } from '../../core/adapters/axios.adapter'

export class SignupService {
  constructor(private httpAdapter: HttpAdapter) {}

  async signup(email: string): Promise<void> {
    await this.httpAdapter.post('', { email })
  }
}
